import { FIELD as TABLE_SORT_FIELD } from './constants'

export const GA_CLICK_ACTION = {
  TABLE_SORT: 'TABLE_SORT',
  READ_MORE: 'READ_MORE',
  VIEW_GD: 'VIEW_GD'
}

export const GA_KEY = {
  TABLE_SORT_CLICKS: 'TABLE_SORT_CLICKS',
  TABLE_SORT_IMPRESSIONS: 'TABLE_SORT_IMPRESSIONS',
  TABLE_SORT_CTR: 'TABLE_SORT_CTR',
  READ_MORE: 'READ_MORE',
  VIEW_GD: 'VIEW_GD'
}

const GA_KEY_MAP = {
  [GA_KEY.TABLE_SORT_CLICKS]: 'keyword_orderclick',
  [GA_KEY.TABLE_SORT_IMPRESSIONS]: 'keyword_orderimpression',
  [GA_KEY.TABLE_SORT_CTR]: 'keyword_orderclickrate',
  [GA_KEY.READ_MORE]: 'keyword_moreitems',
  [GA_KEY.VIEW_GD]: 'keyword_viewgd'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.TABLE_SORT: {
      const map = {
        [TABLE_SORT_FIELD.CLICKS]: GA_KEY.TABLE_SORT_CLICKS,
        [TABLE_SORT_FIELD.IMPRESSIONS]: GA_KEY.TABLE_SORT_IMPRESSIONS,
        [TABLE_SORT_FIELD.CTR]: GA_KEY.TABLE_SORT_CTR
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.READ_MORE:
    case GA_CLICK_ACTION.VIEW_GD:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
